import React from 'react';
import { tokenizeQueryForHighlight, toneClass } from 'searchTokenHighlight';

// Mirrors the search <input> pixel-for-pixel (same font, padding, border,
// line-height) behind its transparent text so recognised column tokens,
// negation dashes and quoted values can be highlighted. aria-hidden since
// the real <input> already carries the accessible value.
const SearchHighlightOverlay = React.forwardRef(({ query, knownTokens, isDark, className }, ref) => {
  const segments = tokenizeQueryForHighlight(query, knownTokens);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      data-testid="search-highlight-overlay"
      className={className}
    >
      {segments.map((segment, index) => (
        <span key={index} className={toneClass(segment.kind, isDark)}>
          {segment.text}
        </span>
      ))}
    </div>
  );
});

export default SearchHighlightOverlay;
